import { wikiLink } from '$utils';
import { useContext } from 'react';
import { TranslatorContext } from '$translation';

export const useWikiLink = (path?: string) => {
  const key = useContext(TranslatorContext).lang;
  return wikiLink(path, key);
};

export const useWikiLinkCallback = (path?: string) => {
  const link = useWikiLink(path);
  return () => window.open(link, '_blank');
};
